import { Helmet } from "react-helmet";
import {
    Autocomplete,
    Box,
    Button,
    Container,
    Checkbox,
    Chip,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Divider,
    FormControl,
    Grid,
    InputLabel,
    Menu,
    MenuItem,
    Paper,
    Select,
    Tab,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tabs,
    TextField,
    Toolbar,
    Typography,
    Avatar,
    InputAdornment,
    FormGroup,
    FormControlLabel,
    FormHelperText,
    RadioGroup,
    Radio,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles, withStyles } from "@mui/styles";
import { Link as RouterLink, useNavigate, useParams } from "react-router-dom";
import React, { useEffect } from "react";
import cssVariables from "../../theme/cssVariables";
import CloseIcon from "../../assets/images/plus-circle-fill.svg";
import linkedGoal from "../../assets/images/linkedGoal.svg";
import defaultProfile from "../../assets/images/defaultProfile.svg";
import arrowLinkedGoal from "../../assets/images/arrowLinkedGoal.svg";
import kpiArrow from "../../icons/kpiArrow.svg";
import Icon from '@mui/material/Icon';
import fileBrowser from "../../icons/file-browser.svg";
import Search from "@mui/icons-material/Search";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../services/global.service";
import { ReactComponent as Nodata } from "../../assets/icons/nodata.svg";
import { ReactComponent as Route } from "../../assets/images/route.svg";
import { ReactComponent as Calendar } from "../../assets/icons/calendar.svg";
import { ReactComponent as BackIcon } from "../../icons/arrow-left.svg";
import { ReactComponent as Time } from "../../assets/icons/time.svg";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
// import DatePicker from '@mui/lab/DatePicker';
// import TimePicker from '@mui/lab/TimePicker';
import StaticTimePicker from '@mui/lab/StaticTimePicker';
import SimpleDialog from "../../components/SimpleDialog";
import ConfirmDialog from "../../components/ConfirmDialog";
import manageForm from "../../services/manageForm.service";
import { ReactComponent as ChevronExpandDown } from "../../assets/icons/chevron-expand-down.svg";
import { ReactComponent as ChevronExpandUp } from "../../assets/icons/chevron-expand-up.svg";

const useStyles = makeStyles({
    select: {
        '& div ': {
            padding: "7.9px 7.9px 7.9px 15px"
        },
    },
    boxLeft: {
        width: "25%",
        "padding-bottom": "25px",
    },
    boxRight: {
        width: "75%",
        "padding-bottom": "25px",
    },
    flexPaper: {
        flex: 1,
        minWidth: 350,
        "border-radius": "10px !important"
    },
    root: {
        display: 'flex',
        flexWrap: 'wrap',
        marginTop: "25px"
    },
    plusSvg: {
        "& > path": {
            fill: "#fff",
            stroke: "#fff",
        },
    },
    desktopView: {
        "& .MuiPaper-root": {
            width: "584px",
            boxShadow: "0px 24px 23px rgba(0, 0, 0, 0.04)"
        },
        "& .PrivatePickersToolbar-root": {
            maxWidth: "unset",
            width: "270px",
            padding: "16px 24px",
        },
        "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-separator": {
            width: "24px",
            padding: "16px 0",
            fontSize: "48px",
            fontWeight: "700",
            lineHeight: "56px",
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.87)"
        },
        "& .PrivatePickersToolbar-root .MuiTypography-root": {
            // fontSize: "10px",
            // fontWeight: "400",
            // lineHeight: "16px",
            color: "rgba(0, 0, 0, 0.6)"
        },
        "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-hourMinuteLabel button .MuiTypography-root": {
            width: "96px",
            padding: "16px 0",
            fontSize: "48px",
            fontWeight: "500",
            lineHeight: "56px",
            textAlign: "center",
            background: "rgba(33, 33, 33, 0.08)",
            borderRadius: "4px",
            color: "rgba(0, 0, 0, 0.87)"
        },
        "& .PrivatePickersToolbar-root .PrivateTimePickerToolbar-hourMinuteLabel button .MuiTypography-root.Mui-selected": {
            background: "rgba(93, 161, 150, 0.15)",
            color: "#5DA196"
        },
        "& .PrivateTimePickerToolbar-ampmSelection": {
            border: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: "4px",
        },
        "& .PrivateTimePickerToolbar-ampmSelection button:first-child": {
            borderRight: "1px solid rgba(0, 0, 0, 0.12)",
            borderRadius: "0",
        },
        "& .PrivateTimePickerToolbar-ampmSelection .MuiTypography-root": {
            fontSize: "20px",
            padding: "8px 0",
            fontWeight: "500",
            lineHeight: "24px",
            textAlign: "center",
            color: "rgba(0, 0, 0, 0.87)"
        },
        "& .PrivateTimePickerToolbar-ampmSelection .MuiTypography-root.Mui-selected": {
            color: "#5DA196",
            background: "rgba(93, 161, 150, 0.15)",
            width: "100%",
        },
        "& .MuiClockPicker-arrowSwitcher": {
            visibility: "hidden"
        },
        "& div > div > div >  .MuiButtonBase-root": {
            visibility: "hidden"
        },
        "& div > .PrivateTimePickerToolbar-hourMinuteLabel > button": {
            visibility: "unset !important"
        },
        "& div > .PrivateTimePickerToolbar-ampmSelection > button": {
            visibility: "unset !important",
            width: "50%",
        },
    }
});


const DialogRoute = (props) => {
    const { open, close, dataFilter, currentData, valueFormType, valueCycleName, valueTemplateName } = props
    const classes = useStyles();
    const { t, i18n } = useTranslation();
    const [isNext, setIsNext] = React.useState(false);
    const [isRoute, setIsRoute] = React.useState(false);
    const [search, setSearchValue] = React.useState("");
    const [items, setItems] = React.useState([]);
    const [mainItems, setMainItems] = React.useState([]);
    const [lengthResult, setLengthResult] = React.useState(0);
    const [startDate, setStartDate] = React.useState(null);
    const [value, setValue] = React.useState(new Date());
    const [checkResired, setCheckRsquired] = React.useState({});
    const [reSet, setreSet] = React.useState(false);
    const [employee, setEmployee] = React.useState([]);
    const [val, setVal] = React.useState([]);
    const [selected, setSelected] = React.useState([]);
    useEffect(() => {
        dataSerachs()
    }, [search]);
    useEffect(() => {
        if (open) {
            formik.resetForm()
            setSearchValue("")
            setSelected([])
            setIsNext(false)
            setIsRoute(false)
            setStartDate(null)
            setValue(new Date())
            setEmployee(Util.formatData(currentData, []))
            dataSerachs(Util.formatData(currentData, []))
        }
    }, [open]);
    const dataSerachs = (datas) => {
        let result = []
        let dataSerach = JSON.parse(JSON.stringify(datas !== undefined && datas !== null ? datas : employee))
        if (search !== "" && dataSerach !== undefined && dataSerach.length > 0) {
            console.log(search);
            let resultData = dataSerach.filter(rs => {
                return Object.keys(rs).some(key => {
                    if (key === 'code' || key === 'name' || key === 'position' || key === 'organization' || key === 'form_name') {
                        return rs[key].toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                    if (key === 'form_status') {
                        return rs[key].label.toString().toLowerCase().indexOf(search.toString().toLowerCase()) !== -1;
                    }
                });
            });
            result = resultData
        } else {
            result = dataSerach;
        }
        setLengthResult(result.length);
        setMainItems(result)
        console.log(result, 999);
    };
    const handleCloseDialog = () => {
        close(false);
        setIsNext(false)
        setIsRoute(false)
    };
    const handleSubmit = () => {
        // setIsNext(false)
        // setIsRoute(false)
        setDiscardDialog(true)
    };
    const handleSearch = (event) => {
        setSearchValue(event.target.value);
    };
    const validationSchema = yup.object({
        cycle: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        formType: yup.string().required(t('admin.inputForm.msgError.nameTH')),
        formTemplate: yup.string().required(t('admin.inputForm.msgError.nameTH')),
    });

    const formik = useFormik({
        initialValues: {
            cycle: "",
            formType: "",
            formTemplate: "",
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: (values) => {
            let data = {
                form_type: values?.formType,
                cycle_id: values?.cycle,
                form_template: values?.formTemplate
            }
            manageForm.getRouteListEmployees(data).then((rs) => {
                setEmployee(Util.formatData(rs?.data?.employees, []))
                dataSerachs(Util.formatData(rs?.data?.employees, []))
                setIsNext(true)
            }).catch((err) => {
            })
        },
    });
    const formikChange = (val, field) => {
        formik.setFieldValue(field, val.target.value)
    }

    const submit = (data) => {
        formik.submitForm()
    }
    const handleRoute = () => {
        setIsRoute(true)
        setIsNext(false)
    }
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = mainItems.map((n) => n.id);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, serial) => {
        const selectedIndex = selected.indexOf(serial);
        let newSelected = [];

        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, serial);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1),
            );
        }

        setSelected(newSelected);
    };
    const isSelected = (serial) => selected.indexOf(serial) !== -1;

    const onCheckStartDate = (val) => {
        setStartDate(Util.formatDate(val))
    }

    const [isSuccessDeleteDialogOpen, openSuccessDeleteDialog] = React.useState(false);
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        let data = {
            form_type: Util.formatData(valueFormType, "evaluate"),
            cycle_id: Util.formatData(valueCycleName, ""),
            form_template: Util.formatData(valueTemplateName, ""),
            until: startDate + " " + Util.formatTime(value),
            forms: Util.formatData(selected, [])
        }
        manageForm.reOpen(data).then((rs) => {
            handleDiscardDialog(false)
            openSuccessDeleteDialog(true)
        }).catch((err) => {

        })
    };
    const handleDirect = () => {
        openSuccessDeleteDialog(false)
        close("load");
    }
    const selectRoute = (field, data) => {
        formik.setFieldValue(field, data)
    };
    const navigate = useNavigate();
    const handleBack = () => {
        if (isNext === true) {
            setIsNext(false)
            setIsRoute(false)
        } else if (isRoute === true) {
            setIsRoute(false)
            setIsNext(true)
        }

    };

    let checkData = () => {
        let check = false
        if (Util.formatData(formik?.values?.formType, false) === false) {
            check = true
        } else if (Util.formatData(formik?.values?.cycle, false) === false) {
            check = true
        } else if (Util.formatData(formik?.values?.formTemplate, false) === false) {
            check = true
        }
        return check
    }

    useEffect(() => {
        formik.setFieldValue("cycle", "")
        formik.setFieldValue("formTemplate", "")
    }, [formik.values.formType]);
    let sortData = (key, check1) => {
        let update = checkResired
        if (check1 === false && update[key] !== check1) {
            mainItems.sort(function (b, a) {
                if (key === "employee") {
                    if (a[key].name > b[key].name) {
                        return -1;
                    }
                    if (b[key].name > a[key].name) {
                        return 1;
                    }
                } else {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                }

                return 0;
            });
            update = { [key]: false }
            setCheckRsquired(update)
            setreSet(!reSet)
        } else if (check1 === true && update[key] !== check1) {
            mainItems.sort(function (a, b) {
                if (key === "employee") {
                    if (a[key].name > b[key].name) {
                        return -1;
                    }
                    if (b[key].name > a[key].name) {
                        return 1;
                    }
                } else {
                    if (a[key] > b[key]) {
                        return -1;
                    }
                    if (b[key] > a[key]) {
                        return 1;
                    }
                }
                return 0;
            });
            update = { [key]: true }
            setCheckRsquired(update)
            setreSet(!reSet)
        }
    }
    let showTemplateName = (data) => {
        let name = ""
        if (Util.formatData(data?.code, "") !== "") {
            name += data.code + " - "
        }
        if (i18n.language === "th-TH") {
            if (Util.formatData(data?.name_th, "") !== "") {
                name += data.name_th
            } else if (Util.formatData(data?.name_en, "") !== "") {
                name += data.name_en
            }
        } else {
            if (Util.formatData(data?.name_en, "") !== "") {
                name += data.name_en
            } else if (Util.formatData(data?.name_th, "") !== "") {
                name += data.name_th
            }
        }
        return name
    }
    const toTimestamp = (strDate) => {
        if (strDate !== "" && strDate !== null && strDate !== undefined) {
            const dt = Date.parse(strDate);
            return dt / 1000;
        } else {
            return 0;
        }
    }
    let checkBelow = () => {
        let check = false
        if (Util.formatData(value, false) !== false && Util.formatData(startDate, false) !== false && selected.length > 0) {
            const date = startDate.replace(/-/g, "/")
            let time = date + " " + Util.formatTime(value)
            let timeStamp = toTimestamp(time)
            for (let index = 0; index <= selected.length - 1; index++) {
                if (check === false) {
                    let filterData = employee.filter((rs) => rs.id === selected[index])
                    if (filterData.length > 0) {
                        if (timeStamp < toTimestamp(filterData[0]?.end_at)) {
                            check = true
                        }
                    }
                }
            }
        }
        return check
    }
    return (
        <Dialog onBackdropClick={() => { return false }} open={open} onClose={handleCloseDialog} aria-labelledby="form-dialog-title" fullWidth={true} maxWidth={isRoute ? "sm" : "xl"} PaperProps={{ sx: { padding: '30px 30px' } }}>
            <DialogTitle id="form-add-dialog-title" fontSize={24} lineHeight="26.4px" sx={{ padding: "0 0 20px" }}>
                <Box sx={{ display: "flex", alignItems: "center", }}>
                    {isRoute ?
                        <Box pr="20px" sx={{ display: "flex", alignItems: "center" }}>
                            <BackIcon style={{ cursor: "pointer" }} onClick={handleBack} />
                        </Box>
                        : null
                    }
                    <Typography fontWeight="600" fontSize={24} lineHeight="26.4px" color="#404349">
                        Reopen
                    </Typography>
                </Box>
                <Box sx={{ position: "absolute", right: 0, margin: "30px 30px 0  0", top: 0 }}><img onClick={handleCloseDialog} className="clickable" src={CloseIcon} alt="browser" /></Box>
            </DialogTitle>
            <Divider />
            <DialogContent sx={{ padding: "0" }}>
                {
                    isRoute ?
                        <Box>
                            <Typography fontWeight="500" color="#404349" fontSize={18} lineHeight="26.91px" pt="20px" pb="8px">
                                Reopen Until:
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: 'space-between', ".MuiOutlinedInput-input": { color: "#404349", padding: "8.5px 14px", paddingRight: "0" }, ".MuiOutlinedInput-root": { maxWidth: "250px", width: "100%" } }}>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <Box pr="15px">
                                        <DatePicker
                                            slots={{
                                                OpenPickerIcon: Calendar
                                            }}
                                            inputformat="dd/MM/yyyy"
                                            value={startDate}
                                            onChange={(newValue) => {
                                                onCheckStartDate(newValue)
                                            }}
                                            inputProps={{ placeholder: t('admin.inputForm.placeholder.selectDate'), readOnly: true }}
                                            renderInput={(params) => <TextField {...params} />
                                            }
                                        />
                                    </Box>
                                </LocalizationProvider>
                                <LocalizationProvider dateAdapter={AdapterDateFns} >
                                    <Box pl="15px">
                                        <TimePicker
                                            ampm
                                            slots={{
                                                OpenPickerIcon: Time
                                            }}
                                            showToolbar={true}
                                            orientation="landscape"
                                            value={value}
                                            onChange={(newValue) => setValue(newValue)}
                                            inputProps={{ placeholder: t('admin.inputForm.placeholder.selectTime'), readOnly: true }}
                                            PopperProps={{
                                                // sx: popperSx
                                                className: classes.desktopView
                                            }}
                                            renderInput={(params) => <TextField {...params} />}
                                        />
                                    </Box>
                                </LocalizationProvider>
                            </Box>
                            <Box sx={{ textAlign: "center" }} pt="30px">
                                <Button
                                    size="small"
                                    aria-controls="simple-menu"
                                    aria-haspopup="true"
                                    onClick={handleSubmit}
                                    color="primary"
                                    variant="contained"
                                    sx={{ height: "45px", p: "0 20px", textTransform: "none" }}
                                    disabled={Util.formatData(value, false) === false || Util.formatData(startDate, false) === false}
                                >
                                    <Typography sx={{ textTransform: "none" }} fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFF">
                                        {t('admin.label.reopen')}
                                    </Typography>
                                </Button>
                            </Box>
                        </Box>
                        :
                        <Box sx={{ overflow: "hidden", height: "calc(100vh - 180px)" }}>
                            <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" color="#A3A3A3" pt="20px" >
                                Please select the item for reopen.
                            </Typography>
                            <Typography fontWeight="400" fontSize={16} lineHeight="23.92px" pt="20px" color="#404349">
                                Showing {mainItems.length} results
                            </Typography>
                            <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }} pt="10px">
                                <Box sx={{ width: "100%", maxWidth: "400px" }}>
                                    <TextField
                                        id="input-with-icon-textfield"
                                        fullWidth
                                        // placeholder={t('label.search')}
                                        placeholder="Search"
                                        size="small"
                                        sx={{ background: "#fff", width: "100%", "input": { padding: "11px 14px" }, ".MuiOutlinedInput-root": { color: "#404349", } }}
                                        className="searchTextField-h40"
                                        value={search}
                                        onChange={handleSearch}
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Search style={{ color: "#C4C4C4" }} />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Box>
                                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                                    {selected.length > 0 ?
                                        <Box sx={{ backgroundColor: "#5DA1961A", padding: "9.05px 20px", borderRadius: "5px" }}>
                                            <Typography color="#5DA196" fontSize={18} lineHeight="26.91px" fontWeight={400} >Selected Items: {selected.length}</Typography>
                                        </Box>
                                        : null
                                    }
                                    <Button
                                        size="small"
                                        aria-controls="simple-menu"
                                        aria-haspopup="true"
                                        onClick={handleRoute}
                                        color="primary"
                                        variant="contained"
                                        sx={{ height: "45px", p: "0 20px", textTransform: "none", "margin-left": "30px" }}
                                        disabled={selected.length > 0 ? false : true}
                                    >
                                        <Route className={classes.plusSvg} />
                                        <Typography pl="10px" sx={{ textTransform: "none" }} fontSize={18} lineHeight="26.91px" fontWeight="500" color="#FFF">
                                            {t('admin.label.reopen')}
                                        </Typography>
                                    </Button>
                                </Box>
                            </Box>
                            <div className={classes.root}>
                                <Paper className={classes.flexPaper} >
                                    <Box sx={{ background: "#FAFAFA" }}>
                                        <Box
                                            py="15px"
                                            sx={{ display: "flex", "flex-direction": "row" }}
                                        >
                                            {/* 33.97+15+25.03+13+13 */}
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "33.97%" }} pr="20px">
                                                <Checkbox
                                                    sx={{ margin: "0 20px", padding: "0" }}
                                                    checked={employee.length > 0 && selected.length === employee.length}
                                                    indeterminate={selected.length > 0 ? selected.length !== employee.length : false}
                                                    onChange={handleSelectAllClick}
                                                />
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('label.titleForm.template')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "15%" }} pr="20px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.workflowStatus')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "25.03%" }} pr="20px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.employeeName')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "13%" }} pr="20px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.startDate')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                                </Typography>
                                            </Box>
                                            <Box sx={{ display: "flex", "flex-direction": "row", width: "13%" }} pr="20px">
                                                <Typography fontSize={16} lineHeight="23.96px" color="#A0A0A0" fontWeight="300px" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                    {t('admin.label.EndDate')}
                                                </Typography>
                                                <Typography component="span" style={{ "flex-direction": "column", "justify-content": "center", "display": "flex" }}>
                                                    <ChevronExpandUp style={{ cursor: "pointer" }} onClick={e => sortData("name", true)} />
                                                    <ChevronExpandDown style={{ cursor: "pointer" }} onClick={e => sortData("name", false)} />
                                                </Typography>
                                            </Box>

                                        </Box>
                                    </Box>
                                    <Box sx={{ overflowY: "overlay", height: " calc(100vh - 400px)" }}>
                                        {mainItems !== undefined && mainItems !== null && mainItems.length > 0 ? mainItems.map((row, index) => {
                                            const isItemSelected = isSelected(row.id)
                                            return (
                                                <Box>
                                                    <Box sx={{ width: "100%", position: "relative" }}>
                                                        <Box
                                                            sx={{ height: "70px", background: "#FFF", width: "100%", display: "flex", "align-items": "center" }}
                                                        >
                                                            {/* 33.97+15+25.03+13+13 */}
                                                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "33.97%" }} pr="20px">
                                                                <Box sx={{ display: "flex", alignItems: "center" }}
                                                                    onClick={(event) => handleClick(event, row?.id)}
                                                                    role="checkbox"
                                                                    aria-checked={isItemSelected}
                                                                    tabIndex={-1}
                                                                    key={row.serial}
                                                                    selected={isItemSelected}>
                                                                    <Checkbox
                                                                        sx={{ margin: "0 20px", padding: "0" }}
                                                                        // onChange={e => changeType(data?.serial)} 
                                                                        checked={isItemSelected}
                                                                    />
                                                                </Box>
                                                                <Box sx={{ width: "calc(100% - 40px)" }} >
                                                                    <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                        {Util.formatData(row?.template?.name, "-")}
                                                                    </Typography>
                                                                </Box>
                                                            </Box>
                                                            {/* <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "15%" }} pr="20px">
                                                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                    {Util.formatData(row?.form_status?.label, "-")}
                                                                </Typography>
                                                            </Box> */}
                                                            <Box py="8px" px="20px" sx={{ display: "flex", alignItems: "center", "flex-direction": "row", "max-width": "100%", width: "15%", border: row?.form_status?.code === "draft" && row?.type !== "goal" ? "1px solid #DADADA" : "none", "border-radius": "5px", background: row?.form_status?.code === "draft" && row?.type !== "goal" ? "none" : row?.form_status?.color + "1A" }} pr="20px">
                                                                <Typography fontSize={16} lineHeight="23.96px" fontWeight={400} color={row?.form_status?.color} sx={{ "text-align": "center", "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis" }}>
                                                                    {Util.formatData(row?.form_status?.label, "-")}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "25.03%" }} pr="20px">
                                                                <Box sx={{ width: "100%", display: "flex", alignItems: "center", "flex-direction": "row", }}>
                                                                    <Avatar
                                                                        src={Util.formatData(row?.employee?.photo, "")}
                                                                        sx={{
                                                                            cursor: "pointer",
                                                                            width: 40,
                                                                            height: 40,
                                                                        }}
                                                                    />
                                                                    <Box sx={{ width: "calc(100% - 40px)" }} pl="20px">
                                                                        <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                            {Util.formatData(row?.employee?.name, "-")} ({Util.formatData(row?.employee?.code, "-")})
                                                                        </Typography>
                                                                        <Typography pt="2px" fontSize={14} lineHeight="20.93px" color="#A3A3A3" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                            {Util.formatData(row?.employee?.position, "-")} {Util.formatData(row?.employee?.organization, false) === false ? "" : `(${row?.employee?.organization})`}

                                                                        </Typography>
                                                                    </Box>
                                                                </Box>
                                                            </Box>
                                                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "13%" }} pr="20px">
                                                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                    {Util.formatData(row?.form?.start_at, false) !== false ? Util.dateDayTimeFormatAdmin(row?.form?.start_at) : "-"}
                                                                </Typography>
                                                            </Box>
                                                            <Box sx={{ display: "flex", alignItems: "center", "flex-direction": "row", width: "13%" }} pr="20px">
                                                                <Typography fontSize={16} lineHeight="23.96px" color="#404349" fontWeight="400" sx={{ "white-space": "nowrap", width: "100%", overflow: "hidden", "text-overflow": "ellipsis", "max-width": "max-content", "margin-right": "10px" }}>
                                                                    {Util.formatData(row?.form?.end_at, false) !== false ? Util.dateDayTimeFormatAdmin(row?.form?.end_at) : "-"}
                                                                </Typography>
                                                            </Box>
                                                        </Box>
                                                    </Box>
                                                    <Divider width="100%" />
                                                </Box>
                                            )
                                        })
                                            :
                                            <Box sx={{ "padding-top": "50px", "text-align": "center" }}>
                                                <Nodata />
                                                <Typography color="#A0A0A0" fontWeight="500" fontSize={20} lineHeight="30px" >
                                                    {t('label.noDataFilter')}
                                                </Typography>
                                                <Typography color="#A0A0A0" fontWeight="400" fontSize={16} lineHeight="24px" >
                                                    {t('label.tryChangingFilter')}
                                                </Typography>
                                            </Box>
                                        }
                                    </Box>
                                </Paper>
                            </div>
                        </Box>
                }
            </DialogContent>
            <SimpleDialog
                open={isSuccessDeleteDialogOpen}
                setValue={openSuccessDeleteDialog}
                text="Form was reopened"
                doDirect={() => handleDirect()}
                page={true}
            />
            <ConfirmDialog
                open={discardDialog}
                warning={true}
                doConfirm={() => handleDiscardChangeConfirm()}
                setValue={() => handleDiscardDialog(false)}
                title="Confirmation of Reopen"
                twoText={true}
                text={checkBelow() ? "Form(s) end date will be changed to an earlier date.<br>Are you sure to reopen ?" : "Are you sure to reopen ?"} />
        </Dialog>
    );
};
export default DialogRoute;
